import React, { useState } from "react";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import toast from "react-hot-toast";
import axios from "../../API/axios";

  const Bookmark = ({ jobId, issavedbyyou }) => {
  const sessionId = localStorage.getItem("sessionId");
  const [loading, setLoading] = useState(false);
  const [isBookmarked, setIsBookmarked] = useState(issavedbyyou); // Track bookmark status


  {/*.............................Bookmark:- SavedJob Api  Start............................*/ }
  const SavedJob = async () => {
    console.log("saved===>");
    setLoading(true);
    try {
      const response = await axios.post(`/JobAction/SaveJob`, {
        sessionId: sessionId,
        jobId: jobId,
      });

      console.log("SavedJob", response);
      toast.success(response.data.message);
      setIsBookmarked(true); // Set as bookmarked
      
    } catch (error) {
      console.error("Error saving job:", error);
      toast.error(error.response?.data?.message || "An error occurred.");
    } finally {
      setLoading(false);
    }
  };
  {/*..............................Bookmark:- SavedJob Api  End.............................*/ }

  {/*...........................UnBookmark:- UnSavedJob Api  Start..........................*/ }
  const UnSavedJob = async () => {
    setLoading(true);
    try {
      const response = await axios.post(`/JobAction/UnSaveJob`, {
        sessionId: sessionId,
        jobId: jobId,
      });
      console.log("UnSavedJob", response);
      toast.success(response.data.message);
      setIsBookmarked(false); // Set as unbookmarked
    } catch (error) {
      console.error("Error unsaving job:", error);
      toast.error(error.response?.data?.message || "An error occurred.");
    } finally {
      setLoading(false);
    }
  };
  {/*............................UnBookmark:- UnSavedJob Api  End............................*/ }


  return (
    <>
      {/*.....................       Bookmark and UnBookmark Icon Start        .......................*/}
      {isBookmarked ? (
        <BookmarkIcon
          className="mb-3 mt-2 BookmarkIcon"
          onClick={UnSavedJob}
          style={{ cursor: "pointer", }} // Optional styling
        />
      ) : (
        <BookmarkBorderIcon
          className="mb-3 mt-2 BookmarkIcon"
          onClick={SavedJob}
          style={{ cursor: "pointer" }} // Optional styling
        />
      )}
      {/*.....................       Bookmark and UnBookmark Icon End        .......................*/}

    </>
  );
};

export default Bookmark;
